// Basic
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import { CUSTOM_BREAKPOINTS_KEYS } from '@core/constants/customBreakpoints.constants';
import { AuthService } from '@services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-no-plan-dialog',
  templateUrl: 'no-plan-dialog.component.html',
  styleUrls: ['no-plan-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NoPlanDialogComponent implements OnInit {


  private isMobile: boolean;
  private mediaSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<NoPlanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mediaObserver: MediaObserver,
    private authService: AuthService,
    private router: Router
  ) { }

  public ngOnInit() {
    this.mediaSubscription = this.mediaObserver.asObservable().subscribe((changes: MediaChange[]) => {
      if (changes) {
        this.isMobile = !!changes.filter((change) => {
          return change.mqAlias === CUSTOM_BREAKPOINTS_KEYS.LT_SM ||
            change.mqAlias === CUSTOM_BREAKPOINTS_KEYS.SM || change.mqAlias === CUSTOM_BREAKPOINTS_KEYS.XS;
        }).length;
        if (!this.isMobile) {
          this.dialogRef.updateSize('800px', '700px');
        } else {
          this.dialogRef.updateSize('100vw', '100vh');
        }
      }
    });
  }

  public goToReactivatePlan() {
    this.router.navigate(['/no-plan']);
    this.close();
  }

  public closeDialog() {
    this.authService.doLogout();
    this.close();
  }

  private close() {
    this.mediaSubscription.unsubscribe();
    this.dialogRef.close();
  }
}
